/**
 * ceci le container de contenue du collapse protocole d'integration
 */
import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import "@css/pages/pointeuse/pointeuse.css";

import AddButton from "@components/buttons/AddButton";

import ItemProtocole from "./itemsIntegrationProtocole";

function IntegrationProtocole(props) {
  const { t } = useTranslation("beginEnd.protocol");
  const protocolList = useSelector(
    ({ onboarding }) => onboarding.protocol.list
  );

  const [isCreating, setIsCreating] = useState(false);
  function onAddProtocolClicked() {
    setIsCreating(true);
  }

  function closeCreation() {
    setIsCreating(false);
  }

  return (
    <div className="arh-w-full arh-bg-white arh-p-4 arh-px-9">
      <AddButton
        label={t("Créer un Protocole")}
        labelClass="arh-font-bold arh-text-base"
        onClick={onAddProtocolClicked}
      />
      <div className="arh-px-0">
        {isCreating && (
          <ItemProtocole
            isCreating
            closeCreation={closeCreation}
          />
        )}
        {protocolList.map((protocol) => (
          <ItemProtocole
            key={protocol._id}
            protocol={protocol}
            closeCreation={closeCreation}
          />
        ))}
      </div>
    </div>
  );
}

export default IntegrationProtocole;
